import { Injectable } from '@angular/core';
import { DescriptionFilePrimitives, Task } from '../../master-data/domain/task';
import { DescriptionFileCacheService } from './description-file-cache.service';
import { FileDownloadProgress, FileDownloadStatuses } from '../../file-download/domain/file-download.types';
import { DateRange } from '../../master-data/domain/date-range';
import { TaskService } from '../../tasks/domain/task.service';

@Injectable({
  providedIn: 'root',
})
export class DescriptionFilesPrefetchService {
  constructor(
    private readonly descriptionFileCacheService: DescriptionFileCacheService,
    private readonly taskService: TaskService
  ) {}

  async prefetchTodayTaskDescriptionFiles(tasks: Array<Task>): Promise<void> {
    const todayTasks = tasks.filter((task) => task.inRange(DateRange.today()) && task.hasDescriptionFiles());

    for (const task of todayTasks) {
      for (const descriptionFile of task.descriptionFiles) {
        const attachmentsDirectory = this.taskService.getAttachmentsDirectoryForTaskId(task.id);
        const hasLocalCopy = await this.descriptionFileCacheService.hasLocalCopy(descriptionFile, attachmentsDirectory);
        if (hasLocalCopy) {
          continue;
        }

        await this.downloadIgnoringErrors(descriptionFile, attachmentsDirectory);
      }
    }
  }

  private async downloadIgnoringErrors(
    descriptionFile: DescriptionFilePrimitives,
    destinationFolder: string
  ): Promise<void> {
    await new Promise<void>((resolve) => {
      const downloadTask = this.descriptionFileCacheService.downloadToCache(descriptionFile, destinationFolder, {
        timeoutInMilliseconds: 45_000,
        maxBytes: 15 * 1024 * 1024,
      });

      const subscription = downloadTask.progress$.subscribe({
        next: (event: FileDownloadProgress) => {
          if (event.status === FileDownloadStatuses.Completed || event.status === FileDownloadStatuses.Cancelled) {
            console.log('Download completed or cancelled', event.status);
            subscription.unsubscribe();
            resolve();
          }
        },
        error: () => {
          subscription.unsubscribe();
          resolve();
        },
      });
    });
  }
}
